import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import ViewRecipePage from '../pages/ViewRecipe';
import EditRecipePage from '../pages/EditRecipe';
import SearchRecipePage from '../pages/SearchRecipe';
import LoginPage from '../pages/LoginPage';
import NewPasswordPage from '../pages/NewPasswordPage';
import ProtectedRoute from '../components/ProtectedRoute';
import ImportPage from '../pages/ImportPage';
import LoginLayout from '../layouts/LoginLayout';


export const router = createBrowserRouter([
  {
    element:<LoginLayout />,
    children: [
      {
        path: '/login',
        element: <LoginPage />,
      },
      {
        path: '/newpassword',
        element: <NewPasswordPage />,
      },
    ],
  },
  {
    element:<MainLayout />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [
          {
            index: true,
            element: <Navigate to="/search" />,
          },
          {
            path: '/recipe',
            children: [
              {
                path: 'new',
                element: <EditRecipePage />,
              },
              {
                path: ':recipeId',
                element:<ViewRecipePage />,
              },
              {
                path: ':recipeId/edit',
                element: <EditRecipePage />,
              },
              {
                path: 'import',
                element: <ImportPage />,
              },
            ],
          },
          {
            path: '/search',
            element: <SearchRecipePage />,
          },
        ],
      },
    ],
  },
]);
